"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const HeaderPart_1 = require("./HeaderPart");
const ContactUsPart_1 = require("../../components/ContactUsPart");
const FooterPart_1 = require("../../components/FooterPart");
const PartnersPart_1 = require("../../components/PartnersPart");
const Management_1 = require("./Management");
const DocumentTitle = require("react-document-title");
class LandingService extends React.Component {
    componentDidMount() {
        document.body.scrollTop = 0;
        $('#serviceItem').addClass('active-item');
    }
    componentWillUnmount() {
        $('#serviceItem').removeClass('active-item');
    }
    render() {
        return React.createElement(DocumentTitle, { title: "LoyalReach - Services" }, React.createElement(react_bootstrap_1.Grid, { fluid: true, className: "landing-service" }, React.createElement(HeaderPart_1.default, null), React.createElement(Management_1.default, null), React.createElement(PartnersPart_1.default, null), React.createElement(ContactUsPart_1.default, null), React.createElement(FooterPart_1.default, null)));
    }
}
exports.default = LandingService;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/howItWorks/components/HowItWorks.tsx
// module id = 1101
// module chunks = 0 1